import React, { Component, useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";

import { FlatList, View, Text, Image, TouchableHighlight, ActivityIndicator} from "react-native-web";


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;


const MenuModalPC = forwardRef((props, ref) => {
    const popupRef = useRef(null);



    /*
    const openMenu = () => {
        console.log("Menu is opened!");
        // Add your logic here (state update, animation, etc.)
    };

    useImperativeHandle(ref, () => ({
        openMenu,
    }));
    */


    useEffect(() => {
         const handleClickOutside = (event) => {
             if (popupRef.current && !popupRef.current.contains(event.target)) {

               if (document.getElementById("myNav").style.display !== 'none')
               {
                   //alert(' === ' + global.closeBtnClicked);
                   setTimeout(() => {
                     props.handleClosePopMenu();
                   },200);

                }
             }
         };

         document.addEventListener("mousedown", handleClickOutside);
         return () => {
             document.removeEventListener("mousedown", handleClickOutside);
         };
     }, []);

    const onMenuItemPressed = (key) => {
        if (key === 'Home')
        {
           window.location = '/';
        }
        else if (key === 'Account_settings')
        {
           window.location = '/myaccount';
        }
        else if (key === 'Saveds')
        {
           window.location = '/saveditems';
        }
        else if (key === 'Courses')
        {
           window.location = '/mycourses';
        }
        else if (key === 'Payments')
        {
           window.location = '/payments';
        }
        else if (key === 'Signout')
        {

              localStorage.removeItem('storrypagejwtToken');
              localStorage.removeItem('storrypageUser');
              localStorage.removeItem('storrypageAfter');

              setTimeout(() => {
                 window.location = "/";
              },100);
        }
    }





    const dataVisitor = [
      {key: 'Home', title: i18n.t('Home'), icon: '/img/home_icon.png'},
      {key: 'Account_settings', title: i18n.t('Account_settings'), icon: '/img/settings_icon.png'},
      {key: 'Saveds', title: i18n.t('Mysaveds'), icon: '/img/saved_icon.png'},
    //  {key: 'Courses', title: i18n.t('Mycourses'), icon: '/img/course_icon.png'},
      //{key: 'Payments', title: i18n.t('Payments'), icon: '/img/payment_icon.png'},
      {key: 'Signout', title: i18n.t('Signout'), icon: '/img/signout_icon.png'},
    ];


    return (
      <div id="myNav" ref={popupRef}
              style={{display: 'none', position: 'fixed', top: '70px', right: '10px', zIndex: 99,
                 width: '300px', height:  '240px', borderRadius: '6px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.5)',
                     background: '#fff', textAlign: 'center', lineHeight: '45px', fontSize: '16px'}}>

              <FlatList data={dataVisitor}
                   showsHorizontalScrollIndicator={false}
                   renderItem={({ item,index }) =>  (
                     <TouchableHighlight underlayColor="transparent" onPress={() => {onMenuItemPressed(item.key)}}>
                       <View style={{flexDirection: 'row', height: 60,}}>

                          <View style={{width: 36, height: 60, marginLeft: 5}}>

                              <View style={{width: 36, height: 60, justifyContent: 'center'}}>
                                {item.key === 'Payments' &&
                                  <Image source={{uri: item.icon}} style={{width: 32, height: 32, marginLeft: 5}}/>
                                }
                                {item.key === 'Home' &&
                                  <Image source={{uri: item.icon}} style={{width: 30, height: 30, marginLeft: 3}}/>
                                }
                                {item.key !== 'Payments' && item.key !== 'Home' &&
                                   <Image source={{uri: item.icon}} style={{width: 36, height: 36, marginLeft: 0}}/>
                                 }
                              </View>

                          </View>
                          <View style={{width: 240, height: 60, marginLeft: 15, justifyContent: 'center', borderTop: index === 0 ? 'none':'1px solid #ddd'}}>
                             <Text style={{color: '#111', fontSize: 17, textAlign: 'left'}}>{item.title}</Text>
                          </View>
                       </View>
                     </TouchableHighlight>
                   )}
                   keyExtractor={(item, index) => ''+index}
                   />




       </div>
    );

});

export default MenuModalPC;
